<template>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec ">
            <div class="loop_container bg-transparent update-request-form-common">
                <div class="card form-wrapper">
                    <div class="row" v-if="hasData">
                        <div class="col-md-12 text-center">
                            <img v-if="logoURL" :src="logoURL" class="top-logo custom-logo"
                                :alt="'Community Logo of ' + community.content.parameter4">
                        </div>
                    </div>
                    <div class="not-found" style="text-align:center; padding:2rem">
                        <h1>404</h1>
                        <p>Sorry, we couldn't find that page.</p>
                        <a :href="landingUrl" target="_self" rel="noopener noreferrer">
                            Go back{{ communityName ? ' to ' + communityName : '' }}
                        </a>
                    </div>
                </div>
                <footer v-if="hasData">
                    <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links"
                                v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length"
                                tabindex="0">Learn More</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links"
                                v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length"
                                tabindex="0">Terms Of Use [pdf]</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                        </li>
                        <!-- <li>
                                <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                                <a href="javascript:void(0)" v-else>Opt Out</a>
                            </li> -->
                    </ul>
                    <div class="unsubscribe-community-logo">
                        <a href="https://www.protopia.co" target="_blank"><img tabindex="0" :src="footerLogoURL"
                                :alt="'Community Logo of ' + community.content.parameter4"><span class="sr-only">Protopia
                                - Visit our site</span></a>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/services/API'
import {getFooterURL, getLogoURL} from "../helpers/getCustomSettings";

/**
 * Only allow absolute http(s) URLs.
 * Anything else → return '/'
 */
function sanitizeUrl(raw) {
    try {
        // Try to parse it as a URL; if relative, base off current origin
        const url = new URL(raw, window.location.origin)
        if (url.protocol === 'http:' || url.protocol === 'https:') {
            return url.toString()
        }
    } catch (e) {
        // invalid URL
    }
    return '/'
}
export default {
    name: 'NotFound',
    props: {
        community_id: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            api: new API(),
            hasData: true,
            landingUrl: '/', // safe default
            communityName: '',
            community: {},
            footerLogoURL: '',
            logoURL: ''
        }
    },
    async created() {
        if (!this.community_id) {
            this.hasData = false
            return
        }
        try {
            await this.api.get(
                `communities/${this.community_id}/community-request`
            ).then(community => {
                this.community = community.data
                document.title = `404${this.community.content.parameter2 ? ' - ' + this.community.content.parameter2 : ' Page not Found'}`
                const customSettings = this.community.customSettings;
                // sanitize whatever comes back
                this.landingUrl = sanitizeUrl(this.community.content.landingPageURL)
                this.communityName = this.community.content.parameter2
                this.logoURL = getLogoURL(customSettings);
                this.footerLogoURL = getFooterURL(customSettings);
            });
        } catch (err) {
            // on any fetch error (404 or others), show generic 404
            console.error('Could not fetch community data for 404 page', err)
            this.hasData = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue